function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  stroke: "#1739e6",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  "data-name": "Path 232",
  d: "M9.111 32.772V14.484a5.379 5.379 0 015.379-5.379h0a5.379 5.379 0 015.379 5.379v18.288"
}), React.createElement("path", {
  "data-name": "Path 233",
  d: "M3.466 23.09a13.985 13.985 0 1122.049 0"
}), React.createElement("path", {
  "data-name": "Line 154",
  d: "M13.415 17.711h2.152"
}));

var SvgFinger = function SvgFinger(props) {
  return React.createElement("svg", _extends({
    width: 28.982,
    height: 33.272
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC45ODIiIGhlaWdodD0iMzMuMjcyIiB2aWV3Qm94PSIwIDAgMjguOTgyIDMzLjI3MiI+CiAgPGcgaWQ9InRhcC0wMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuOTk1IC0wLjAwMSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMjMyIiBkYXRhLW5hbWU9IlBhdGggMjMyIiBkPSJNNS41LDI4LjE2N1Y5Ljg3OUE1LjM3OSw1LjM3OSwwLDAsMSwxMC44NzksNC41aDBhNS4zNzksNS4zNzksMCwwLDEsNS4zNzksNS4zNzlWMjguMTY3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjYwNiA0LjYwNikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzE3MzllNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzIzMyIgZGF0YS1uYW1lPSJQYXRoIDIzMyIgZD0iTTQuNDYxLDIzLjA5MWExMy45ODUsMTMuOTg1LDAsMSwxLDIyLjA0OSwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMTczOWU2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMTU0IiBkYXRhLW5hbWU9IkxpbmUgMTU0IiB4Mj0iMi4xNTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0LjQxIDE3LjcxMikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzE3MzllNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgFinger as ReactComponent };